import { render } from "./TSMDefectsListPage.vue?vue&type=template&id=dbfa012e"
import script from "./TSMDefectsListPage.vue?vue&type=script&lang=js"
export * from "./TSMDefectsListPage.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__